import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/lib/firebase'
import App from './App.jsx'
import './index.css'
import './i18n/config.js'

// Disable browser scroll restoration on this app — after Phase 3 the menu
// loading skeleton reserves enough height (min-h-[80vh]) for the browser
// to "restore" the previous scroll position once the page settles, which
// landed the customer past the banner / sticky nav on F5. We control
// scroll explicitly via the routes; the default for a fresh load is top.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

// Warm the Firestore WebChannel handshake — the single slowest part of
// the cold menu load. By kicking off a getDoc here (before React renders),
// the transport negotiates in parallel with bundle parse + React boot
// instead of waiting until useRestaurant's first call. restaurantSlugs is the
// first doc useRestaurant reads, so the prefetch lands in persistentLocalCache
// before it asks. The restaurant doc itself is private (ENG-491).
const restaurantPathMatch = window.location.pathname.match(/^\/(?:r|restaurants)\/([^/?#]+)/)
if (restaurantPathMatch) {
  const [, restaurantIdOrSlug] = restaurantPathMatch
  getDoc(doc(db, 'restaurantSlugs', restaurantIdOrSlug)).catch(() => {
    // A failed warm-up is harmless: the channel negotiated anyway.
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
